import { IModule, IModuleBuilder } from 'app/IModule';
import { CommoditiesReducer, CommodityConfigurationReducer, MyCommoditiesReducer } from './commodities.reducer';
import { ExchangesReducer } from './exchanges.reducer';
import { CurrenciesReducer } from './currencies.reducer';
import { UnitsConversionRatesReducer, UnitsReducer } from './units.reducer';

export default class CommodityModule implements IModule {
	build(builder: IModuleBuilder) {
		builder.addReducer('allCommodities', new CommoditiesReducer());
		builder.addReducer('myCommodities', new MyCommoditiesReducer());
		builder.addReducer("commodityConfiguration", new CommodityConfigurationReducer());
		builder.addReducer("exchanges", new ExchangesReducer());
		builder.addReducer("currencies", new CurrenciesReducer());
		builder.addReducer("units", new UnitsReducer());
		builder.addReducer("unitsConversionRates", new UnitsConversionRatesReducer());
	}
}
